import { Inline, spacingHelper } from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { PropertyFeature } from './subcomponents/PropertyFeature/PropertyFeature';

interface PropertyFeaturesProps {
  items: PropertyFeature[];
  className?: string;
}

export const PropertyFeaturesContainer = styled(Inline)`
  flex-wrap: wrap;
  row-gap: ${spacingHelper('twoExtraSmall')};
`;

export const PropertyFeatures: FunctionComponent<PropertyFeaturesProps> = ({
  items,
  className,
}) => {
  return (
    <PropertyFeaturesContainer grow={false} gap="small" className={className}>
      {items.map(({ iconName, title, valueWithUnit, hoverTitle }) => (
        <PropertyFeature
          key={title}
          iconName={iconName}
          title={title}
          valueWithUnit={valueWithUnit}
          hoverTitle={hoverTitle}
        />
      ))}
    </PropertyFeaturesContainer>
  );
};
